import { Injectable } from '@angular/core';
import { Apollo, gql } from 'apollo-angular';
import type { Observable } from 'rxjs';
import { map } from 'rxjs';
import type { ModalityInterface } from '../models/modality.interface';

@Injectable({
  providedIn: 'root'
})
export class ModalityService {
  constructor(private readonly apollo: Apollo) { }

  getModalities(): Observable<ModalityInterface[]> {
    return this.apollo.query<{ modalitiesFromClinicId: ModalityInterface[] }>({
      query: gql`query modalitiesFromClinicId {
        modalitiesFromClinicId {
          id
          name
          aet
          modalityTypeId
          modalityTypeName
          ip
          port
          lastPing
          diskLeftPercent
        }
      }`
    }).pipe(map(res => res.data.modalitiesFromClinicId));
  }
}
